var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1976d2",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M59 17h-6v19a6.006 6.006 0 0 1-6 6H29.128l-8 7H39.68l13.739 9.813A.988.988 0 0 0 54 59a1.019 1.019 0 0 0 .458-.11A1 1 0 0 0 55 58v-9h4a4 4 0 0 0 4-4V21a4 4 0 0 0-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 4H5a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h6v13a1 1 0 0 0 .587.91A.983.983 0 0 0 12 54a1 1 0 0 0 .658-.247L28.376 40H47a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.88597014e8ee8e2e1d4b9f8b8290228f.svg";
export { ForwardRef as ReactComponent };